import LogoMark from "./LogoMark";

export default function Logo({ light = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={34} />
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
        Quantora
      </span>
    </span>
  );
}
